import {Component, OnInit} from '@angular/core';

import {AuthenticationService} from "@shared/services/authentication/authentication.service";

import {AuthenticationRoutesNames} from "@shared/constans/authentication-routes-names.constans";

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styles: []
})
export class LogoutComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService) {
  }

  ngOnInit(): void {
    this.authenticationService.closeSession().subscribe({
      next: () => this.goToLoginWithTabRealod(),
      error: () => this.goToLoginWithTabRealod(),
    });
  }

  private goToLoginWithTabRealod() {
    const loginRoute = AuthenticationRoutesNames.getFullName(AuthenticationRoutesNames.login);
    // przeładowanie aplikacji jest zrobione po to to żeby wyczyścić cache i uniknąć problemu widzenia danych poprzedniego klienta
    window.location.assign(loginRoute);
  }
}
